import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { getTransactionsUpdateCostList } from '@store/INV/Transactions/UpdateCost/InvUpdateCostSlice';

const useGetUpdateCostList = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (UpdateCostList?.length === 0) {
      dispatch(getTransactionsUpdateCostList());
    }
  }, []);
  const { UpdateCostList, loading , error } = useAppSelector((state) => state.InvUpdateCost);

  return { UpdateCostList, loading , error };
};

export default useGetUpdateCostList;
